import { connect } from 'react-redux'
import styled from 'styled-components'
import { select } from '@/store'
import { colors, fontSizes, fontWeights } from '@/styles'
import htmlToReact from '@/utils/html-to-react'

export const Wrapper = styled.div`
  ${({ customStyle }) => customStyle}

  .section-heading {
    font-size: ${fontSizes.large};
    line-height: 28px;
    font-weight: ${fontWeights.bold};
    margin-top: 45px;
    margin-bottom: 25px;
  }
  .sub-heading,
  .sub-sub-heading {
    font-size: ${fontSizes.regularMobile};
    line-height: 20px;
    font-weight: ${fontWeights.bold};
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    font-size: ${fontSizes.small};
  }

  a[href] {
    font-size: ${fontSizes.small};
    text-decoration: none;
    color: ${colors.link};

    &.summary-link {
      padding-bottom: 10px;
      display: block;
    }
  }

  a[href=''] {
    font-size: inherit;
    color: inherit;
  }

  li {
    font-size: ${fontSizes.small};
    margin-bottom: 10px;
  }

  .jumplink:before {
    content: '';
    display: block;
    position: relative;
    width: 0;
    height: 110px;
    margin-top: -110px;
  }
`

const mapState = (state, ownProps) => {
  const agreement = select.agreement.agreements(state, ownProps) || {}
  return { description: agreement.description }
}

const Description = ({ description }) =>
  description ? <Wrapper>{htmlToReact(description)}</Wrapper> : null

Description.defaultProps = {
  description: null
}

const AgreementDescription = connect(mapState)(Description)

export default AgreementDescription
